// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.singlefamily.RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  CreateSingleFamilyFeesRequestDto,
  FeeType,
  GetSingleFamilyFeesResponseDto,
  ListingAlias,
  SingleFamilyFeeDto,
  UpdateSingleFamilyFeesRequestDto,
} from '../..';

interface DeleteParams {
  costAndFeeId: string;
  listingAlias: ListingAlias;
}
interface GetParams {
  listingAlias: ListingAlias;
}
interface GetFeesForTypeParams {
  feeType: FeeType;
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Path =
  '/api/web/v1/users/properties/fees/singleFamily/create';

/**
 * Creates a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create = (
  postData: CreateSingleFamilyFeesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreateSingleFamilyFeesRequestDto, SingleFamilyFeeDto>({
    endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/fees/singleFamily/delete';

/**
 * Deletes a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete = (
  getParams: DeleteParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<DeleteParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Path =
  '/api/web/v1/users/properties/fees/singleFamily/get';

/**
 * Retrieve all fees for a given single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get = (
  getParams: GetParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetParams, never, GetSingleFamilyFeesResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Path =
  '/api/web/v1/users/properties/fees/singleFamily/getFeesForType';

/**
 * Deletes a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType = (
  getParams: GetFeesForTypeParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetFeesForTypeParams, never, Array<SingleFamilyFeeDto>>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Path =
  '/api/web/v1/users/properties/fees/singleFamily/update';

/**
 * Update a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update = (
  postData: UpdateSingleFamilyFeesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, UpdateSingleFamilyFeesRequestDto, SingleFamilyFeeDto>({
    endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};
